
 // Abroad banner 
(async function(){
  const abroadEl = document.getElementById('abroadBox');

  try {
    // ipapi.co の例： https://ipapi.co/json/
    const res = await fetch('https://ipapi.co/json/');
    if (!res.ok) throw new Error('API error');

    const data = await res.json();
    const country = (data.country || '').toUpperCase();

    if (country && country !== 'JP') {
      abroadEl.classList.add('visible');
    }
  } catch (err) {
    console.warn('Geo API failed:', err);
    const lang = navigator.language || navigator.userLanguage || '';
    if (!lang.startsWith('ja')) {
      abroadEl.classList.add('visible');
    }
  }
})();
